module.exports = require('./helpers/bundle-url').getBundleURL('UckoE') + "carousel-arrow-left.0618f939.png" + "?" + Date.now();